<div>
  <div class="card">
    <div class="card-header">
      <div class="workspace-header">

        <!-- TITLE -->
        <div>
          Specialist Workspace
        </div>

        <!-- FILTERS -->
        <div class="workspace-filters">

          <div class="p-2 filter-block">
            <label class="filter-label">
              Priority Task Types
              <app-components-helptext
                [key]="'SpecialistWorkspace_PriorityTask'">
              </app-components-helptext>
            </label>

            <app-multi-select-with-all
              [options]="taskTypes"
              idField="TaskTypeId"
              labelField="Name"
              width="375px"
              panelMaxHeight="480px"
              (idsChange)="onTaskTypeIdsChange($event)">
            </app-multi-select-with-all>
          </div>


          @if (canFilterLanguages) {
            <div class="p-2 filter-block">
              <label class="filter-label">
                Languages
                <app-components-helptext
                  [key]="'SpecialistWorkspace_Languages'">
                </app-components-helptext>
              </label>

              <app-multi-select-with-all
                [options]="languageOptions"
                idField="languageId"
                labelField="fullName"
                width="250px"
                panelMaxHeight="480px"
                (idsChange)="onLanguageIdsChange($event)">
              </app-multi-select-with-all>
            </div>
          }

          <div class="p-2 filter-block">
            <label class="filter-label">
              CMS
              <app-components-helptext
                [key]="'SpecialistWorkspace_CMS'">
              </app-components-helptext>
            </label>

            <app-multi-select-with-all
              [options]="cmsOptions"
              idField="ContentManagementSystemId"
              labelField="Name"
              width="250px"
              panelMaxHeight="480px"
              (idsChange)="onCmsIdsChange($event)">
            </app-multi-select-with-all>
          </div>

        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <button
            [disabled]="isLoading()"
            (click)="getNextTaskInQueue()"
            class="btn btn-danger"
            [ngClass]="customerButtonCss">

            <ng-container *ngIf="theme !== themes.regular">
              <i [ngClass]="icon" class="fa-3x" id="action-button-icon"></i><br>
            </ng-container>

            <span>GET NEXT ACTION</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="hasWebsiteBookmarkingPermissions" class="card">
    <div class="card-header">
      Options
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <button
            class="btn btn-primary btn-sm"
            (click)="deleteWebsiteBookmarkingSkips();">
            Clear Website Bookmarking Skips
          </button>

          <app-components-helptext
            [key]="'SpecialistWorkspace_DeleteCustomerSkips'">
          </app-components-helptext>
        </div>
      </div>
    </div>
  </div>
</div>
